/* Revvi Parts Finder — daltons2wheels.com/collections/revvi
   Self-contained: injects its own styles + UI into #revvi-finder,
   fetches the collection's products.json and filters client-side on
   the fitment markers carried in product_type. */
(function () {
  "use strict";

  var MOUNT_ID = "revvi-finder";
  var DATA_URL = window.REVVI_DATA_URL || "/collections/revvi/products.json";

  /* ---------- data model ---------- */

  var MODELS = [
    { id: "12", label: "12″" },
    { id: "16", label: "16″" },
    { id: "16-plus", label: "16″ Plus" },
    { id: "16-xl", label: "16″ XL" },
    { id: "18", label: "18″" },
    { id: "20", label: "20″" },
    { id: "20-plus", label: "20″ Plus" },
    { id: "24", label: "24″" },
    { id: "e250", label: "E-250" }
  ];

  /* Pull model ids ("16-plus", "20", ...) out of a fitment string.
     Sizes must be word-bounded so years (2026) and voltages never match. */
  function modelTokens(s) {
    var found = [], m;
    var rx = /\b(12|16|18|20|24)\b\s*(?:"|”)?\s*\b(plus|xl)?\b/gi;
    while ((m = rx.exec(s))) {
      var id = m[1] + (m[2] ? "-" + m[2].toLowerCase() : "");
      if (found.indexOf(id) < 0) found.push(id);
    }
    if (/E-?250/i.test(s)) found.push("e250");
    return found;
  }

  var TABS = [
    { id: "all", label: "Everything" },
    { id: "spare", label: "Replacement Parts" },
    { id: "upgrade", label: "Upgrade Parts" },
    { id: "bike", label: "Bikes" },
    { id: "gear", label: "Riding Gear & Accessories" }
  ];

  var CAT_NAMES = {
    "Brakes, Calipers & Levers": "Brakes, Calipers & Levers",
    "Brake Discs, Drums & Pads": "Brake Discs, Drums & Pads",
    "Rechargeable Batteries": "Batteries & Charging",
    "Tyres & Tubes": "Tyres & Tubes",
    "Wheels & Wheelsets": "Wheels",
    "Suspension, Forks & Shocks": "Suspension & Forks",
    "Drivetrain, Chains, Sprockets & Pedals": "Chains, Sprockets & Pedals",
    "Electric Bike Components": "Electrical Components",
    "Control Units & ECUs": "Controllers & ECUs",
    "Frame, Body & Other Parts": "Frame & Bodywork",
    "Handlebars, Grips, Stems & Seats": "Bars, Grips & Seats",
    "Axles, Bearings & Spacers": "Axles, Bearings & Spacers",
    "Decals, Graphics & Name Boards": "Decals & Graphics",
    "Helmets & Protective Clothing": "Helmets & Clothing"
  };

  function norm(s) {
    return (s || "").replace(/[″”“′]/g, '"');
  }

  function classify(p) {
    var pt = norm(p.product_type);
    var title = norm(p.title);
    var type;
    if (/Upgrade/i.test(pt)) type = "upgrade";
    else if (/Spares/i.test(pt)) type = "spare";
    else if (/Bikes\b/.test(pt)) type = "bike";
    else type = "gear";

    /* Fitment evidence: only the product-line tokens ("Revvi 16" Plus Spares",
       "18" Bikes") — NOT the parent "16" Bike Upgrades" menu categories, which
       also hang Plus/XL parts under plain 16 — plus the "to fit ..." tail of
       the title. Never the title head (part sizes like "16" Rim Tape"). */
    var evidence = pt.split(" > ").filter(function (tok) {
      tok = tok.trim();
      return /(Spares|Bikes)\b/.test(tok) && tok !== "Revvi Bike Spares";
    }).join(" > ");
    var tail = title.match(/(?:to fit|for use with|fits)([^]*)$/i);
    if (tail) evidence += " | " + tail[1];
    var models = type === "gear" ? [] : modelTokens(evidence);
    /* Bikes list themselves under a bare "Electric Bikes" token sometimes
       (20" Plus, 24") — fall back to the bike's own name. */
    if (type === "bike" && !models.length) models = modelTokens(title);

    var cats = [];
    var m, rx = /Ebay - ([^>]+?)(?: >|$)/g;
    while ((m = rx.exec(pt))) {
      var name = CAT_NAMES[m[1].trim()];
      if (name && cats.indexOf(name) < 0) cats.push(name);
    }

    var prices = p.variants.map(function (v) { return parseFloat(v.price); });
    var minP = Math.min.apply(null, prices);
    var maxP = Math.max.apply(null, prices);
    return {
      title: p.title,
      handle: p.handle,
      img: p.images && p.images[0] ? p.images[0].src : null,
      available: p.variants.some(function (v) { return v.available; }),
      priceMin: minP,
      priceFrom: maxP > minP,
      type: type,
      models: models,
      cats: cats
    };
  }

  /* ---------- state ---------- */

  var state = { model: null, tab: "all", cat: null };
  var items = null;      // classified products
  var loadPromise = null;

  function loadData() {
    if (loadPromise) return loadPromise;
    loadPromise = (function fetchPage(page, acc) {
      var sep = DATA_URL.indexOf("?") < 0 ? "?" : "&";
      return fetch(DATA_URL + sep + "limit=250&page=" + page)
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var list = j.products || j;   // live endpoint vs local test file
          acc = acc.concat(list);
          if (list.length === 250) return fetchPage(page + 1, acc);
          return acc;
        });
    })(1, []).then(function (all) {
      items = all.map(classify);
      return items;
    });
    return loadPromise;
  }

  /* ---------- filtering ---------- */

  function matches(it) {
    if (state.tab !== "all" && it.type !== state.tab) return false;
    if (state.tab === "all" && it.type === "gear" && state.model) return false;
    if (state.model && it.type !== "gear" && it.models.indexOf(state.model) < 0) return false;
    if (state.cat && it.cats.indexOf(state.cat) < 0) return false;
    return true;
  }

  function results() {
    var out = items.filter(matches);
    out.sort(function (a, b) {
      if (a.available !== b.available) return a.available ? -1 : 1;
      if (a.type !== b.type) {
        var order = { bike: 0, upgrade: 1, spare: 2, gear: 3 };
        return order[a.type] - order[b.type];
      }
      return a.title.localeCompare(b.title);
    });
    return out;
  }

  /* ---------- rendering ---------- */

  var root, els = {};

  /* NOTE: the theme (Dawn/Ride family) sets html font-size to 62.5%, so 1rem = 10px
     on the live site. Everything here is in px so it renders identically in any context,
     and the cards copy the theme's own look: big white image, solid dark caption block,
     bold heading-font title, "£xx.xx GBP" price, square corners, page-width container. */
  var CSS = "" +
    "#revvi-finder{margin:0 auto;padding:30px 0 10px;color:rgb(var(--color-foreground,18,18,18))}" +
    "#revvi-finder .rf-box{border:1px solid rgba(var(--color-foreground,18,18,18),.15);padding:24px 24px 28px}" +
    "#revvi-finder h2{margin:0 0 6px;font-family:var(--font-heading-family,inherit);font-size:28px;line-height:1.1;text-transform:uppercase;letter-spacing:.06em}" +
    "#revvi-finder .rf-sub{margin:0 0 18px;font-size:15px;opacity:.75}" +
    "#revvi-finder .rf-label{display:block;font-size:12px;text-transform:uppercase;letter-spacing:.1em;opacity:.65;margin:18px 0 8px}" +
    "#revvi-finder .rf-chips{display:flex;flex-wrap:wrap;gap:8px}" +
    "#revvi-finder button.rf-chip{cursor:pointer;font:inherit;font-size:15px;padding:9px 18px;border-radius:999px;border:1px solid rgba(var(--color-foreground,18,18,18),.35);background:transparent;color:inherit}" +
    "#revvi-finder button.rf-chip:hover{border-color:rgba(var(--color-foreground,18,18,18),.8)}" +
    "#revvi-finder button.rf-chip.on{background:rgb(var(--color-foreground,18,18,18));color:rgb(var(--color-background,255,255,255));border-color:rgb(var(--color-foreground,18,18,18))}" +
    "#revvi-finder select.rf-cat{font:inherit;font-size:15px;padding:9px 14px;border-radius:0;border:1px solid rgba(var(--color-foreground,18,18,18),.35);background:rgb(var(--color-background,255,255,255));color:rgb(var(--color-foreground,18,18,18));max-width:100%}" +
    "#revvi-finder .rf-status{margin:22px 0 0;font-size:15px;display:flex;align-items:center;gap:16px;flex-wrap:wrap}" +
    "#revvi-finder .rf-status b{font-size:18px}" +
    "#revvi-finder a.rf-reset{color:inherit;opacity:.7;text-decoration:underline;cursor:pointer;font-size:14px}" +
    "#revvi-finder .rf-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;margin-top:16px}" +
    "@media(max-width:990px){#revvi-finder .rf-grid{grid-template-columns:repeat(2,1fr)}}" +
    "@media(max-width:749px){#revvi-finder .rf-grid{grid-template-columns:repeat(2,1fr)}#revvi-finder .rf-box{padding:16px}}" +
    "#revvi-finder .rf-card{position:relative;background:#fff;display:flex;flex-direction:column}" +
    "#revvi-finder .rf-card a{color:inherit;text-decoration:none;display:flex;flex-direction:column;height:100%}" +
    "#revvi-finder .rf-card img{width:100%;aspect-ratio:1/1;object-fit:contain;background:#fff;display:block}" +
    "#revvi-finder .rf-noimg{width:100%;aspect-ratio:1/1;background:#f2f2f2}" +
    "#revvi-finder .rf-info{padding:18px 20px 20px;background:rgb(var(--color-foreground,18,18,18));color:rgb(var(--color-background,255,255,255));display:flex;flex-direction:column;gap:9px;flex:1}" +
    "#revvi-finder .rf-title{font-family:var(--font-heading-family,inherit);font-weight:700;font-size:17px;line-height:1.25;flex:1}" +
    "#revvi-finder .rf-card a:hover .rf-title{text-decoration:underline}" +
    "#revvi-finder .rf-price{font-size:16px}" +
    "#revvi-finder .rf-badge{position:absolute;top:10px;left:10px;background:rgba(18,18,18,.8);color:#fff;font-size:11px;letter-spacing:.05em;text-transform:uppercase;padding:4px 9px}" +
    "#revvi-finder .rf-card.oos img{opacity:.45}" +
    "#revvi-finder .rf-empty{padding:40px 16px;text-align:center;opacity:.7;font-size:16px;grid-column:1/-1}" +
    "#revvi-finder .rf-hide{display:none!important}";

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text) e.textContent = text;
    return e;
  }

  function money(n) {
    return "£" + n.toFixed(2) + " GBP";
  }

  function themeGridSection() {
    var g = document.getElementById("product-grid");
    return g ? g.closest(".shopify-section") : null;
  }

  function build() {
    root.innerHTML = "";
    root.classList.add("page-width");   // theme container: same width + gutters as the product grid
    var style = document.createElement("style");
    style.textContent = CSS;
    root.appendChild(style);

    var box = el("div", "rf-box");
    box.appendChild(el("h2", null, "Find Parts For Your Revvi"));
    box.appendChild(el("p", "rf-sub", "Pick your bike, then choose replacement parts or upgrades. Every result fits the bike you select."));

    box.appendChild(el("span", "rf-label", "1. Your bike"));
    var mRow = el("div", "rf-chips");
    MODELS.forEach(function (m) {
      var b = el("button", "rf-chip", "Revvi " + m.label);
      b.type = "button";
      b.dataset.model = m.id;
      b.addEventListener("click", function () {
        state.model = state.model === m.id ? null : m.id;
        state.cat = null;
        refresh();
      });
      mRow.appendChild(b);
    });
    box.appendChild(mRow);
    els.modelRow = mRow;

    box.appendChild(el("span", "rf-label", "2. What are you looking for?"));
    var tRow = el("div", "rf-chips");
    TABS.forEach(function (t) {
      var b = el("button", "rf-chip", t.label);
      b.type = "button";
      b.dataset.tab = t.id;
      b.addEventListener("click", function () {
        state.tab = t.id;
        state.cat = null;
        refresh();
      });
      tRow.appendChild(b);
    });
    box.appendChild(tRow);
    els.tabRow = tRow;

    var catWrap = el("div");
    catWrap.appendChild(el("span", "rf-label", "3. Narrow it down (optional)"));
    var sel = document.createElement("select");
    sel.className = "rf-cat";
    sel.addEventListener("change", function () {
      state.cat = sel.value || null;
      refresh();
    });
    catWrap.appendChild(sel);
    box.appendChild(catWrap);
    els.catWrap = catWrap;
    els.catSel = sel;

    var status = el("div", "rf-status");
    els.count = el("b");
    status.appendChild(els.count);
    var reset = el("a", "rf-reset", "Reset filters");
    reset.addEventListener("click", function (e) {
      e.preventDefault();
      state = { model: null, tab: "all", cat: null };
      refresh();
    });
    status.appendChild(reset);
    box.appendChild(status);
    els.status = status;

    root.appendChild(box);
    els.grid = el("div", "rf-grid");
    root.appendChild(els.grid);
  }

  function refresh() {
    /* chip highlight */
    Array.prototype.forEach.call(els.modelRow.children, function (b) {
      b.classList.toggle("on", b.dataset.model === state.model);
    });
    Array.prototype.forEach.call(els.tabRow.children, function (b) {
      b.classList.toggle("on", b.dataset.tab === state.tab);
    });

    var active = !!(state.model || state.tab !== "all" || state.cat);
    var themeSec = themeGridSection();

    if (!active) {
      els.status.classList.add("rf-hide");
      els.catWrap.classList.add("rf-hide");
      els.grid.innerHTML = "";
      if (themeSec) themeSec.classList.remove("rf-hide");
      syncUrl();
      return;
    }

    if (themeSec) themeSec.classList.add("rf-hide");
    els.status.classList.remove("rf-hide");

    loadData().then(function () {
      var out = results();

      /* category dropdown: rebuild from what's actually in the result set (pre-cat filter) */
      var savedCat = state.cat;
      state.cat = null;
      var base = items.filter(matches);
      state.cat = savedCat;
      var counts = {};
      base.forEach(function (it) {
        it.cats.forEach(function (c) { counts[c] = (counts[c] || 0) + 1; });
      });
      var catNames = Object.keys(counts).sort();
      var showCats = state.tab !== "bike" && catNames.length > 1;
      els.catWrap.classList.toggle("rf-hide", !showCats);
      if (showCats) {
        els.catSel.innerHTML = "";
        var o0 = document.createElement("option");
        o0.value = "";
        o0.textContent = "All part types";
        els.catSel.appendChild(o0);
        catNames.forEach(function (c) {
          var o = document.createElement("option");
          o.value = c;
          o.textContent = c + " (" + counts[c] + ")";
          els.catSel.appendChild(o);
        });
        els.catSel.value = savedCat && counts[savedCat] ? savedCat : "";
        if (savedCat && !counts[savedCat]) state.cat = null;
      }

      var mLabel = null;
      MODELS.forEach(function (m) { if (m.id === state.model) mLabel = "Revvi " + m.label; });
      var what = { all: "products", spare: "replacement parts", upgrade: "upgrade parts", bike: "bikes", gear: "riding gear & accessories" }[state.tab];
      els.count.textContent = out.length + " " + what + (mLabel ? " for the " + mLabel : "");

      els.grid.innerHTML = "";
      if (!out.length) {
        els.grid.appendChild(el("div", "rf-empty", "Nothing matches those filters yet. Try a different part type, or contact us and we will track it down."));
      }
      out.forEach(function (it) {
        var card = el("div", "rf-card" + (it.available ? "" : " oos"));
        var a = document.createElement("a");
        a.href = "/products/" + it.handle;
        if (it.img) {
          var img = document.createElement("img");
          img.loading = "lazy";
          img.src = it.img + (it.img.indexOf("?") < 0 ? "?" : "&") + "width=520";
          img.alt = it.title;
          a.appendChild(img);
        } else {
          a.appendChild(el("div", "rf-noimg"));
        }
        if (!it.available) card.appendChild(el("span", "rf-badge", "Sold out"));
        else if (it.type === "upgrade") card.appendChild(el("span", "rf-badge", "Upgrade"));
        var info = el("div", "rf-info");
        info.appendChild(el("div", "rf-title", it.title));
        info.appendChild(el("div", "rf-price", (it.priceFrom ? "From " : "") + money(it.priceMin)));
        a.appendChild(info);
        card.appendChild(a);
        els.grid.appendChild(card);
      });
      syncUrl();
    });
  }

  function syncUrl() {
    if (!window.history || !history.replaceState) return;
    var q = [];
    if (state.model) q.push("bike=" + state.model);
    if (state.tab !== "all") q.push("type=" + state.tab);
    if (state.cat) q.push("part=" + encodeURIComponent(state.cat));
    var url = location.pathname + (q.length ? "?" + q.join("&") : "");
    history.replaceState(null, "", url);
  }

  function readUrl() {
    var sp = new URLSearchParams(location.search);
    var bike = sp.get("bike");
    if (bike && MODELS.some(function (m) { return m.id === bike; })) state.model = bike;
    var type = sp.get("type");
    if (type && TABS.some(function (t) { return t.id === type; })) state.tab = type;
    if (sp.get("part")) state.cat = sp.get("part");
  }

  function init() {
    root = document.getElementById(MOUNT_ID);
    if (!root) return;
    build();
    readUrl();
    loadData();     // warm the cache immediately
    refresh();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
